export function useGetCurrentFullUrl() {
  const requestURL = useRequestURL()

  /**
   * Returns the current full URL without the hash in SSR compatible way.
   * @returns The current full URL.
   */
  function getCurrentFullUrl() {
    return requestURL.href.replace(requestURL.hash, '')
  }

  return {
    getCurrentFullUrl,
  }
}
